var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.059,
    height: 24.353,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6707 3.8066C13.3456 3.49726 12.9584 3.2519 12.5315 3.08479C12.1047 2.91769 11.6467 2.83218 11.1845 2.83326C10.7221 2.83218 10.2643 2.91769 9.83744 3.08479C9.41059 3.2519 9.02335 3.49726 8.69822 3.8066L8.49989 3.99993L8.30156 3.81326C7.64401 3.19446 6.75224 2.84683 5.82239 2.84683C4.89253 2.84683 4.00076 3.19446 3.34322 3.81326C2.69429 4.43636 2.33081 5.27408 2.33081 6.1466C2.33081 7.01912 2.69429 7.85685 3.34322 8.47992L8.13864 13.0066C8.23823 13.1002 8.37324 13.1528 8.51406 13.1528C8.6548 13.1528 8.78988 13.1002 8.88947 13.0066L13.6849 8.47992C14.3341 7.85478 14.6963 7.01465 14.6937 6.14053C14.6911 5.2664 14.3237 4.42824 13.6707 3.8066Z",
    fill: "#D60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.207a231f78616f7df8546161f102b65e.svg";
export { ForwardRef as ReactComponent };